import React from "react";

/**
 * Loading placeholder matching the GeoCaptureForm layout — title, the access note, a large capture
 * target and a pinned submit — so the swap to the real form does not reflow the page.
 */
const GeoCaptureSkeleton = (): JSX.Element => (
  <div className="min-h-screen bg-neutral-2 px-4 py-6">
    <div className="mx-auto flex w-full max-w-xl animate-pulse flex-col gap-5 rounded-2xl bg-white p-5 shadow-sm">
      <div className="h-6 w-48 rounded bg-neutral-4" />
      <div className="h-12 w-full rounded-lg bg-neutral-3" />
      <div className="h-4 w-36 rounded bg-neutral-5" />
      <div className="h-40 w-full rounded-md bg-neutral-4" />
      <div className="h-10 w-full rounded-md bg-neutral-4" />
    </div>
  </div>
);

export default GeoCaptureSkeleton;
